import React from 'react';

const PostsIndex = () => {
    return <div>
        List of blog posts.
    </div>
}

export default PostsIndex;